import React__default, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Manager, Reference, Popper } from 'react-popper';
import clsx from 'clsx';
import { useMediaQuery } from '../../util/useMediaQuery.js';
import { propTypes, defaultProps, DEFAULT_MODIFIERS, VARIANT_MAP } from './Tooltip.types.js';
import styles from './Tooltip.module.scss.js';

var TABLET_BREAKPOINT = 768;
var showTimeoutId;
var hideTimeoutId;
var popperUpdate;
var Tooltip = function (props) {
    var className = props.className, children = props.children, variant = props.variant, tooltipClassName = props.tooltipClassName, tooltipContent = props.tooltipContent, disabled = props.disabled, hideArrow = props.hideArrow, delayShow = props.delayShow, delayHide = props.delayHide, portalTarget = props.portalTarget;
    var _a = useState(false), isFocused = _a[0], setIsFocused = _a[1];
    var _b = useState(false), isVisible = _b[0], setIsVisible = _b[1];
    var isMobile = useMediaQuery("(max-width: ".concat(TABLET_BREAKPOINT, "px)"));
    var isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    var shouldShowTooltip = !isMobile || !isTouch;
    var updateTooltip = function () {
        setIsVisible(isFocused);
        popperUpdate && popperUpdate();
    };
    var setVisible = function () {
        if (delayShow) {
            showTimeoutId = window.setTimeout(updateTooltip, delayShow);
        }
        else {
            updateTooltip();
        }
    };
    var setHidden = function () {
        if (delayHide) {
            hideTimeoutId = window.setTimeout(function () { return setIsVisible(false); }, delayHide);
        }
        else {
            setIsVisible(false);
        }
    };
    useEffect(function () {
        isFocused ? setVisible() : setHidden();
        return function () {
            window.clearTimeout(showTimeoutId);
            window.clearTimeout(hideTimeoutId);
        };
    }, [isFocused]);
    var renderTooltipContent = function () {
        var _a;
        var placementName = VARIANT_MAP[variant];
        var tooltipClasses = clsx(styles.TooltipContent, tooltipClassName, (_a = {},
            _a[styles.TooltipContent___visible] = shouldShowTooltip && !disabled && isVisible,
            _a));
        return (React__default.createElement(Popper, { placement: placementName, modifiers: DEFAULT_MODIFIERS }, function (popperParams) {
            var placement = popperParams.placement, ref = popperParams.ref, style = popperParams.style, arrowProps = popperParams.arrowProps, update = popperParams.update;
            popperUpdate = update;
            return (React__default.createElement("div", { ref: ref, style: style, "data-placement": "".concat(placement), "data-variant": variant, className: tooltipClasses, "data-testid": props['data-testid'] },
                tooltipContent,
                !hideArrow && (React__default.createElement("div", { ref: arrowProps.ref, "data-placement": placement, className: styles.Arrow, "data-testid": "".concat(props['data-testid'], "-arrow") }))));
        }));
    };
    return (React__default.createElement(Manager, null,
        React__default.createElement(Reference, null, function (_a) {
            var ref = _a.ref;
            return (React__default.createElement("div", { ref: ref, onMouseEnter: function () { return setIsFocused(true); }, onMouseLeave: function () { return setIsFocused(false); }, onFocus: function () { return setIsFocused(true); }, onBlur: function () { return setIsFocused(false); }, className: clsx(styles.Tooltip, className), "data-testid": "".concat(props['data-testid'], "-wrapper") }, children));
        }),
        isVisible
            ? portalTarget
                ? createPortal(renderTooltipContent(), portalTarget)
                : renderTooltipContent()
            : null));
};
Tooltip.propTypes = propTypes;
Tooltip.defaultProps = defaultProps;
Tooltip.displayName = 'Tooltip';

export { Tooltip, Tooltip as default };
